import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import {
  Col,
  OverlayTrigger,
  ProgressBar,
  Row,
  Tooltip
} from 'react-bootstrap';
import MarketShare from '../../gestionarInmobiliaria/components/MarketShare';
import {
  getStatusDataProject,
  getStatusDataProperty
} from '../propertyWizard/steps/utils/getStatusData';

const StepsStatusWizard = ({ property, project }) => {
  let data = [];
  let messages = [];

  if (property) {
    const { data: propData, messages: propMessages } =
      getStatusDataProperty(property);
    data = propData;
    messages = propMessages;
  } else {
    const { data: projData, messages: projMessages } =
      getStatusDataProject(project);
    data = projData;
    messages = projMessages;
  }

  const totalStorage = data
    .map(step =>
      step
        .map(d => d.size)
        .reduce((total, currentValue) => total + currentValue, 0)
    )
    .reduce((total, currentValue) => total + currentValue, 0);

  const emptyTotal = data
    .map(step =>
      step
        .filter(d => d.color === '300')
        .map(d => d.size)
        .reduce((total, currentValue) => total + currentValue, 0)
    )
    .reduce((total, currentValue) => total + currentValue, 0);

  const convertToMarketShareData = dataSteps => {
    return dataSteps.flat().map(d => ({
      id: d.id,
      name: d.name,
      value: (d.size * 100) / totalStorage,
      color: d.color
    }));
  };

  const marketShareData = convertToMarketShareData(data);

  const uniqueMarketShares = [];
  const seenNames = new Set();

  marketShareData.forEach(share => {
    if (!seenNames.has(share.name)) {
      seenNames.add(share.name);
      uniqueMarketShares.push(share);
    }
  });

  return (
    <>
      <div className="d-flex align-items-center">
        <div className="w-100">
          {/* Visualización para pantallas grandes (>= 768px) */}
          <div className="d-none d-md-block">
            <p className="small mb-1">
              Calidad{' '}
              <span className="fw-bolder">
                {emptyTotal === 0
                  ? '100'
                  : `${Math.round(
                      ((totalStorage - emptyTotal) * 100) / totalStorage
                    )}`}
                %
              </span>
            </p>

            <ProgressBar
              style={{ height: 8 }}
              className="shadow-none rounded-3 mb-3"
            >
              {data.map(step =>
                step.map((status, index) => (
                  <OverlayTrigger
                    placement="bottom"
                    key={status.name + index}
                    overlay={
                      <Tooltip
                        id={`tooltip-${status.name}`}
                        className="bg-white text-dark"
                      >
                        {status.name}
                      </Tooltip>
                    }
                  >
                    <ProgressBar
                      isChild
                      variant={status.color}
                      now={(status.size * 100) / totalStorage}
                      style={{
                        borderRight:
                          index === step.length - 1
                            ? '2px solid white'
                            : '' /* `1px solid var(--falcon-colored-link-${status.color}-hover-color)` */
                      }}
                    />
                  </OverlayTrigger>
                ))
              )}
            </ProgressBar>
          </div>

          {/* Visualización para pantallas pequeñas (< 768px) */}
          <div className="d-md-none">
            <MarketShare
              now={
                emptyTotal === 0
                  ? 100
                  : Math.round(
                      ((totalStorage - emptyTotal) * 100) / totalStorage
                    )
              }
              data={uniqueMarketShares}
              radius={['50%', '70%']}
              title="Porciones"
            />
          </div>

          <Row>
            {messages.map((message, index) => (
              <Col key={message.title + index} xs="auto" className="pe-2 small">
                <FontAwesomeIcon
                  icon="circle"
                  className={`text-${message.color} fs--2 me-2`}
                />
                <span>{message.title}</span>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </>
  );
};

StepsStatusWizard.propTypes = {
  property: PropTypes.object,
  project: PropTypes.object
};

export default StepsStatusWizard;
